/* eslint-disable no-shadow */
/* eslint-disable react/display-name */
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";

import BaseStepper from "../../components/modules/BaseStepper";
import Controls from "../../components/CampaignCreation/Controls";
import CustomSlideCheckBoxOption from "../../components/CampaignCreation/CustomSlideCheckBoxOption";
import PageLayout from "../../layouts/PageLayout";
import classes from "./CampaignTemplateCreatePage.module.scss";
import { BaseStep } from "../../components/modules/BaseStepper/BaseStepper";
import {
  createCampaignTemplate,
  resetCampaignToCreateState,
  setCampaignSteps,
} from "../../redux/reducers/campaignToCreate";
import { stepMap, stepOptions, templateSteps as defaultSteps } from "../../constants/steps";

const creationStartedPageLayoutProps = {
  heading: "Campaign Template Creation",
  description: "",
};

const customSlidesSelectionPageLayoutProps = {
  heading: "Design a Scalable Campaign Template.",
  description: "Set up the steps and details that make your campaigns run smoothly. A good template saves time.",
};

const CustomCampainCreatePage: FC = () => {
  const [customSlideOptions, setCustomSlideOptions] = useState(() =>
    stepOptions.reduce((acc, step) => {
      acc[step.name] = false;
      return acc;
    }, {} as Record<string, boolean>),
  );

  const [steps, setSteps] = useState<BaseStep[]>(defaultSteps);

  const [hasStartedCustomCampaignCreation, setHasStartedCustomCampaignCreation] = useState(false);

  const toggleStep = (checked: boolean, stepComponent: BaseStep) => {
    setSteps((prev) =>
      checked ? [...prev, stepComponent] : prev.filter((step) => (step as any).label !== stepComponent.label),
    );
  };

  const handleCustomSlideOptionsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, name } = event.target;

    setCustomSlideOptions((prev) => ({ ...prev, [name]: checked }));

    const step = stepMap[name];
    if (step) {
      toggleStep(checked, step);
    }
  };

  const dispatch = useDispatch();

  const handleGetStarted = () => {
    dispatch(setCampaignSteps(steps.map((step) => step.name)));
    setHasStartedCustomCampaignCreation(true);
  };

  const handleBack = () => {
    dispatch(resetCampaignToCreateState());
    setHasStartedCustomCampaignCreation(false);
  };

  return (
    <PageLayout
      heading={
        hasStartedCustomCampaignCreation
          ? creationStartedPageLayoutProps.heading
          : customSlidesSelectionPageLayoutProps.heading
      }
      description={
        hasStartedCustomCampaignCreation
          ? creationStartedPageLayoutProps.description
          : customSlidesSelectionPageLayoutProps.description
      }
    >
      {hasStartedCustomCampaignCreation ? (
        <BaseStepper
          steps={steps}
          handleBack={handleBack}
          lastStepNextLabel="Create Template"
          campaignAction={createCampaignTemplate}
          typeOfAction="create"
        />
      ) : (
        <>
          <div className={classes.customSlideOptionsContainer}>
            {stepOptions.map((option) => (
              <CustomSlideCheckBoxOption
                key={option.name}
                label={option.label}
                description={option.description}
                icon={option.icon}
                checked={customSlideOptions[option.name]}
                name={option.name}
                handleChange={handleCustomSlideOptionsChange}
              />
            ))}
          </div>
          <Controls handleGetStarted={handleGetStarted} />
        </>
      )}
    </PageLayout>
  );
};

export default CustomCampainCreatePage;
